/**
 *  @file       protocol/index.js
 *  @author     Ryan Rossiter, ryan@kingsds.network
 *  @date       January 2020
 *
 *  The Protocol API represents the low-level entity connection and message-passing interfaces.
 *  The Protocol itself can sit on top of HTTP, HTTP/2, WebSockets, or men in Jeeps with pockets
 *  full of USB keys: the actual transport is irrelevant at the API except level, except for the
 *  protocol field of the URL object used to establish a connection.code.
 */
'use strict';

const { DCPError } = require('dcp/common/dcp-error');
const { DcpURL } = require('dcp/common/dcp-url');
const wallet    = require('dcp/dcp-client/wallet');

var schedulerConfigLocation; /* memo re where dcp-config originated; intended to be authoritative but possible to spoof */

/**
 * This method clears the identity cache that is used by Connection.connect() to track (URL, identity) pairs.
 * 
 * @param {wallet.Keystore | wallet.Address | true} selector - Corresponding cache entry to clear, or all if true.
 */
exports.clearIdentityCache = function  clearIdentityCache(arg) {
  if (true) /* eslint-disable-line no-constant-condition */
  {
    const identityCache = exports.getGlobalIdentityCache();
    if (arg === true) {
      identityCache.clearAll();
    } else if (arg instanceof wallet.Address) {
      identityCache.clearIdentity(arg);
    } else if (arg instanceof wallet.Keystore) {
      identityCache.clearIdentity(arg.address);
    } else {
      throw new Error('Invalid input for clearIdentityCache()');
    }
  }
};

/** @param {DcpURL} location */
exports.fetchSchedulerConfig = async function dcp$$fetchSchedulerConfig(location)
{
  if (schedulerConfigLocation)
    throw new DCPError('Cannot re-fetch scheduler configuration', 'DCPP-1001'); /* security */

  location = new DcpURL(location);
  schedulerConfigLocation = location;
  /* ver param controls output from web-config. Default is 1.0.0.
   * - 2.1.0: ask for serialized object with KVIN v9
   * - 2.0.0: ask for serialized object with KVIN v8 (1.2.18)
   * - 1.0.0: ask for source code for object
   */
  location.searchParams.ver = '2.1.0';

  const request = await require('dcp/utils').reallyJustFetch(location);

  return request.responseText;
}

/** @param {HTMLElement} scriptElement */
exports.setSchedulerConfigLocation_fromScript = function dcp$$setSchedulerConfigLocation_fromScript(scriptElement)
{
  schedulerConfigLocation = new (require('dcp/common/dcp-url').DcpURL)(scriptElement.src);
}

/** @returns DcpURL */
exports.getSchedulerConfigLocation = function dcp$$getSchedulerConfigLocation()
{
  return schedulerConfigLocation;
}

exports.version = {
  provides: '5.0.0', /* semver, must satisfy dcpConfig.scheduler.compatibility.minimum.dcp in dcp-client */
  api: '5.0.0'
};

exports.ErrorPayload = require('./error-payload').ErrorPayload;
Object.assign(exports, require('./connection'));
Object.assign(exports, require('./target'));
Object.assign(exports, require('./identity-cache'));
Object.assign(exports, require('./validity-stamp-cache'))
